var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Prosjektet er ikke planlagt ferdig! ")])
}
var staticRenderFns = []

export { render, staticRenderFns }